import ClearableSelect from "./ClearableSelect";

export default function UserNoPetsFilter({
  param = "withoutPets",
  deleteParams = ["withoutPets"],
}) {

  const noPetsSelectOptions = [
    { value: "true", label: "UsersWithoutPets" },
    { value: "false", label: "UsersWithPets" },
  ];
 return (
    <ClearableSelect
      param={param}
      deleteParams={deleteParams}
      label="PetsFilterLabel"
      options={noPetsSelectOptions}
      testId="users.page.filters.pets-select"
    />
  );
}